import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import Controller from '@ember/controller';

import AccountModel from 'cio/models/account';
import RouterService from '@ember/routing/router-service';
import AuthService from 'cio/services/auth';
import ApiErrorsService from 'cio/services/api-errors';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';
import AccountService from 'cio/services/account';
import MasqService from 'cio/services/masq';

export default class AuthenticatedController extends Controller.extend({
  // This form of queryParams (a map) is not typed accurately: define in .extend() call
  queryParams: { masqAccountID: 'masq_account_id' },
}) {
  @service('account') accountService!: AccountService;
  @service auth!: AuthService;
  @service alerts!: AlertsService;
  @service apiErrors!: ApiErrorsService;
  @service analytics!: AnalyticsService;
  @service router!: RouterService;
  @service masq!: MasqService;

  masqAccountID: string | null = null;

  account!: AccountModel;

  // Determines whether we're within the "app" structure of routes. This is so
  // that we can display the right alerts/banners at the top when necessary
  @computed('router.currentRouteName')
  get isAppRoute() {
    return this.router.isActive('app');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    authenticated: AuthenticatedController;
  }
}
